import React from 'react';
import styled from 'styled-components';
import Box, { IBoxProps } from 'components/core/Box/Box';

const BoxWrapper = ({ children, ...rest }: IBoxProps) => {
  return <StyledBox {...rest}>{children}</StyledBox>;
};

export default BoxWrapper;

const StyledBox = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => (theme.view.isMobile ? '2rem 1.5rem' : '4rem 6rem')} 3rem;
  width: ${({ theme }) => (theme.view.isMobile || theme.view.isSdk ? '100%' : '60rem')};
  ${({ theme }) => theme.view.isMobile && 'height: 100%'};
`;
